import useInitIdpConfigContextFromConfig from './useInitIdpConfigContextFromConfig';
import useInitIdpConfigContextFromRoute from './useInitIdpConfigContextFromRoute';

export const useInitIdpConfigContext = () => {
	const { done: initFromRouteDone } = useInitIdpConfigContextFromRoute();
	const { done: initFromConfigDone } =
		useInitIdpConfigContextFromConfig(initFromRouteDone);

	return initFromConfigDone;
};
